
const SOCIAL = [
    //<a href="github.com/Krythz43">Github</a> | <a href="codeforces.com/profile/nks43">Codeforces</a> | <a href="codechef.com/users/krithick4">Codechef</a>
    {
        id:1,
        website: "Github",
        link: "https://www.github.com/Krythz43"
    },

    {
        id:2,
        website: "Codeforces",
        link: "https://www.codeforces.com/profile/nks43"
    },

    {
        id:3,
        website: "CodeChef",
        link: "https://www.codechef.com/users/krithick4"
    }
];

export default SOCIAL;